/**
 * Phase 6a.19 — derive a single `EngagementStatus` for the UI.
 *
 * The status state machine ([Phase 6a.10 §21.7.4]) writes both the
 * explicit `status` field AND the `isStale` boolean. The
 * `transitionToStale` helper sets `status: "stale"` AND `isStale: true`
 * together, but `isStale` can also be set independently when contracts
 * are edited after a calculation. This helper centralises the priority
 * resolution so every UI surface (history cards, banners, etc.) reads
 * a single source of truth.
 *
 * Priority:
 *   1. `isStale === true`        → "stale"   (an unconfirmed edit
 *                                  invalidated the cached results —
 *                                  this is the most informative signal)
 *   2. explicit `status` field   → use it    (engagement-state machine
 *                                  has spoken)
 *   3. `lastResult` present      → "calculated"  (defensive — never
 *                                  display "draft" when results exist)
 *   4. default                   → "draft"
 */

import type {
  EngagementHistoryEntry,
  EngagementStatus,
} from "@/types";

export function deriveEngagementStatus(
  engagement: EngagementHistoryEntry,
): EngagementStatus {
  if (engagement.isStale) return "stale";
  if (engagement.status) return engagement.status;
  if (engagement.lastResult) return "calculated";
  return "draft";
}
